import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CataloguePage } from "@/features/catalogue/CataloguePage";
import { CATALOGUE_TABS, type CatalogueTab } from "@/features/catalogue/shared";

const search = z.object({
  peek: z.string().optional(),
  folder: z.string().optional(),
});

export const Route = createFileRoute("/_app/catalogue/$tab")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { tab } = Route.useParams();
  const current: CatalogueTab = (CATALOGUE_TABS as readonly string[]).includes(tab) ? (tab as CatalogueTab) : "services";
  return <CataloguePage tab={current} search={Route.useSearch()} />;
}
